import {
    Suspense,
    lazy,
    memo,
} from 'react';
import { useRecoilState } from 'recoil';

import { TranslationProvider } from 'contexts/useTranslationContext';
import { modalState } from 'store/state';
import {
    AUTH_MODAL,
    NO_METAMASK_MODAL,
    TRANSACTION_PENDING_MODAL,
    SEND_ALLOCATION_ADDRESS_MODAL,
} from '_constants/modalTypes';

import FallbackLayer from './FallbackLayer';

const ModalComponents = {};

ModalComponents[AUTH_MODAL] = lazy(() => import('./elements/AuthModal'));
ModalComponents[NO_METAMASK_MODAL] = lazy(() => import('./elements/NoMetamask'));
ModalComponents[TRANSACTION_PENDING_MODAL] = lazy(() => import('./elements/TransactionPending'));
ModalComponents[SEND_ALLOCATION_ADDRESS_MODAL] = lazy(() => import('./elements/SendAllocationAddress'));

const Modal = () => {
    const [modal] = useRecoilState(modalState);
    const CurrentModal = ModalComponents[modal.type];

    if (!CurrentModal) {
        return <></>;
    }

    const ModalComponent = () => <CurrentModal {...modal.options} />;

    return (
        <TranslationProvider>
            <Suspense fallback={<FallbackLayer />}>
                <ModalComponent />
            </Suspense>
        </TranslationProvider>
    );
};

export default memo(Modal);
